module.exports = __webpack_public_path__ + "img/icon-home-ev-01.2beb887f.jpg";